define(function ( require ) {
    return function () {
        var ua = navigator.userAgent, tem, old = false,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);

        var browser = M[0].toLowerCase(),
            version = parseInt(M[1], 10);

        if (
            (browser == 'chrome' && version < 33) ||
            (browser == 'firefox' && version < 31) ||
            (browser == 'safari' && version < 10) ||
            (browser == 'trident' && version < 7) ||
            (browser == 'msie' )
        ) {
            old = true;
        }

        var api = {
            browser: browser,
            version: version,
            old: old
        };

        return api;
    };
});
